import { createReducer, on } from '@ngrx/store';
import { decryptAES } from '../../utils/cipher';
import { keyStorage } from '../../constants/storage';
import { getLocalStorage } from '../../utils/storage';
import * as Action from '../actions/profile.action';

export type initialStateType = {
    isLogin: boolean;
    profileInfo: ProfileInfoType;
    notifyBadge: number;
};

export const initialState: initialStateType = {
    isLogin: Boolean(getLocalStorage(keyStorage?.isLogin)) || false,
    profileInfo: {
        firstName: getLocalStorage(keyStorage.fullName)?.split(' ')[0] || '',
        lastName: getLocalStorage(keyStorage.fullName)?.split(' ')[1] || '',
        email: getLocalStorage(keyStorage.username)
            ? decryptAES(getLocalStorage(keyStorage.username))
            : '',
        privilegeMenu: getLocalStorage(keyStorage.menuKey)?.split(',') || [],
        pushNotification:
            Boolean(getLocalStorage(keyStorage.pushNotification)) || true,
        // role:''
    },
    notifyBadge: 0
};

const _ProfileReducer = createReducer(
    initialState,
    on(Action.SetNotiBadge, (state, action) => {
        console.log("Reducer SetNotiBadge", action.badge)
        return {
            ...state,
            notifyBadge: action.badge
            // profileInfo: {
            //     ...state.profileInfo,
            //     notiBadge: action.badge,
            // },
        };
    }),
    on(Action.SetLogin, (state, action) => {
        return {
            ...state,
            isLogin: true,
            profileInfo: action.data,
        };
    }),
    on(Action.SetLogout, (state) => {
        return {
            ...state,
            isLogin: false,
            profileInfo: initialState.profileInfo,
            notifyBadge: 0
        };
    })
);

export function profileReducer(state, action) {
    return _ProfileReducer(state, action);
}
